import { signal } from '@preact/signals';
import type { ChatMessage, ConnectionStatus, MessageAuthor, WidgetRuntimeConfig } from '../types/public';

export type Screen = 'closed' | 'picker' | 'form' | 'chat';

export const screen = signal<Screen>('closed');
export const runtimeConfig = signal<WidgetRuntimeConfig | null>(null);
export const userName = signal<string>('');
export const consentGiven = signal<boolean>(false);
export const unreadCount = signal<number>(0);

export const messages = signal<ChatMessage[]>([]);
export const currentOperator = signal<MessageAuthor | null>(null);
export const operatorTyping = signal<boolean>(false);
export const connectionStatus = signal<ConnectionStatus>('idle');
export const sessionClosed = signal<boolean>(false);

/**
 * URL фото, открытого в lightbox-overlay'е (или null если закрыт).
 * Tap по фото в чате → выставляем сюда url, оверлей сам отрисуется в App.
 * Закрытие: ESC, click на backdrop, кнопка X — все они сбрасывают на null.
 *
 * Использование внутреннего overlay вместо `<a target=_blank>` решает две вещи:
 *   1. URL `/api/widget/file/...?token=...&clientId=...` не светится в адресной
 *      строке (token публичный, clientId не секрет, но эстетически шакально).
 *   2. UX как в нативных мессенджерах — preview прямо в чате.
 */
export const lightboxUrl = signal<string | null>(null);
export const lightboxAlt = signal<string>('');

export function appendMessage(msg: ChatMessage): void {
  messages.value = [...messages.value, msg];
}

export function updateMessage(id: string, patch: Partial<ChatMessage>): void {
  messages.value = messages.value.map((m) => (m.id === id ? { ...m, ...patch } : m));
}

export function resetChat(): void {
  messages.value = [];
  currentOperator.value = null;
  operatorTyping.value = false;
  sessionClosed.value = false;
}

export function startNewSession(): void {
  sessionClosed.value = false;
  currentOperator.value = null;
  appendMessage({
    id: `system-started-${Date.now()}`,
    direction: 'in',
    type: 'system',
    systemKind: 'session_started',
    sentAt: Date.now(),
    status: 'delivered',
  });
}
